// AUTO-GENERATED by scripts/gen-poi-icon-bboxes.mjs — do not edit by hand.
// Drawing bounding box per poiIcon, keyed by its imported asset URL.
// Value: [lx, ly, bw, bh, vbW, vbH] — drawing bbox in viewport-local units
// (lx,ly,bw,bh) plus the viewport size (vbW,vbH). See the generator header.

import i0 from '../images/poiIcons/aerialway.svg';
import i1 from '../images/poiIcons/aerodrome.svg';
import i2 from '../images/poiIcons/alpine_hut.svg';
import i3 from '../images/poiIcons/american_football.svg';
import i4 from '../images/poiIcons/animal_shelter.svg';
import i5 from '../images/poiIcons/antenna.svg';
import i6 from '../images/poiIcons/apartment.svg';
import i7 from '../images/poiIcons/arch.svg';
import i8 from '../images/poiIcons/archaeological_site.svg';
import i9 from '../images/poiIcons/arts_centre.svg';
import i10 from '../images/poiIcons/artwork.svg';
import i11 from '../images/poiIcons/atm.svg';
import i12 from '../images/poiIcons/attraction.svg';
import i13 from '../images/poiIcons/bank.svg';
import i14 from '../images/poiIcons/bar.svg';
import i15 from '../images/poiIcons/basic_hut.svg';
import i16 from '../images/poiIcons/basketball.svg';
import i17 from '../images/poiIcons/bbq.svg';
import i18 from '../images/poiIcons/beach.svg';
import i19 from '../images/poiIcons/beach_resort.svg';
import i20 from '../images/poiIcons/beehive.svg';
import i21 from '../images/poiIcons/bell_tower.svg';
import i22 from '../images/poiIcons/bench.svg';
import i23 from '../images/poiIcons/bicycle_parking.svg';
import i24 from '../images/poiIcons/bicycle_repair_station.svg';
import i25 from '../images/poiIcons/biergarten.svg';
import i26 from '../images/poiIcons/bird_hide.svg';
import i27 from '../images/poiIcons/board.svg';
import i28 from '../images/poiIcons/boat_rental.svg';
import i29 from '../images/poiIcons/boundary_stone.svg';
import i30 from '../images/poiIcons/bowling_alley.svg';
import i31 from '../images/poiIcons/bridge.svg';
import i32 from '../images/poiIcons/building.svg';
import i33 from '../images/poiIcons/bunker.svg';
import i34 from '../images/poiIcons/bureau_de_change.svg';
import i35 from '../images/poiIcons/bus_station.svg';
import i36 from '../images/poiIcons/bus_stop.svg';
import i37 from '../images/poiIcons/bust.svg';
import i38 from '../images/poiIcons/cafe.svg';
import i39 from '../images/poiIcons/camp_site.svg';
import i40 from '../images/poiIcons/car_wash.svg';
import i41 from '../images/poiIcons/casino.svg';
import i42 from '../images/poiIcons/castle.svg';
import i43 from '../images/poiIcons/cattle_grid.svg';
import i44 from '../images/poiIcons/cave_entrance.svg';
import i45 from '../images/poiIcons/cemetery.svg';
import i46 from '../images/poiIcons/chalet.svg';
import i47 from '../images/poiIcons/charging_station.svg';
import i48 from '../images/poiIcons/chimney.svg';
import i49 from '../images/poiIcons/church.svg';
import i50 from '../images/poiIcons/cinema.svg';
import i51 from '../images/poiIcons/city.svg';
import i52 from '../images/poiIcons/city_gate.svg';
import i53 from '../images/poiIcons/commercial.svg';
import i54 from '../images/poiIcons/community_centre.svg';
import i55 from '../images/poiIcons/construction.svg';
import i56 from '../images/poiIcons/courthouse.svg';
import i57 from '../images/poiIcons/cricket.svg';
import i58 from '../images/poiIcons/cross.svg';
import i59 from '../images/poiIcons/cycle_barrier.svg';
import i60 from '../images/poiIcons/dam.svg';
import i61 from '../images/poiIcons/danger.svg';
import i62 from '../images/poiIcons/defibrillator.svg';
import i63 from '../images/poiIcons/dentist.svg';
import i64 from '../images/poiIcons/doctors.svg';
import i65 from '../images/poiIcons/dog_park.svg';
import i66 from '../images/poiIcons/drinking_spring.svg';
import i67 from '../images/poiIcons/drinking_water.svg';
import i68 from '../images/poiIcons/dyke.svg';
import i69 from '../images/poiIcons/earth_bank.svg';
import i70 from '../images/poiIcons/education/college.svg';
import i71 from '../images/poiIcons/education/nursery.svg';
import i72 from '../images/poiIcons/education/school.svg';
import i73 from '../images/poiIcons/elevator.svg';
import i74 from '../images/poiIcons/embankment.svg';
import i75 from '../images/poiIcons/embassy.svg';
import i76 from '../images/poiIcons/emergency_phone.svg';
import i77 from '../images/poiIcons/entrance.svg';
import i78 from '../images/poiIcons/excrement_bags.svg';
import i79 from '../images/poiIcons/farm.svg';
import i80 from '../images/poiIcons/fast_food.svg';
import i81 from '../images/poiIcons/fell.svg';
import i82 from '../images/poiIcons/fence.svg';
import i83 from '../images/poiIcons/ferry.svg';
import i84 from '../images/poiIcons/fire_station.svg';
import i85 from '../images/poiIcons/firepit.svg';
import i86 from '../images/poiIcons/fishing.svg';
import i87 from '../images/poiIcons/fixme.svg';
import i88 from '../images/poiIcons/ford.svg';
import i89 from "../images/poiIcons/forester's_lodge.svg";
import i90 from '../images/poiIcons/fort.svg';
import i91 from '../images/poiIcons/fortress.svg';
import i92 from '../images/poiIcons/fountain.svg';
import i93 from '../images/poiIcons/free_flying.svg';
import i94 from '../images/poiIcons/fuel.svg';
import i95 from '../images/poiIcons/gate.svg';
import i96 from '../images/poiIcons/golf.svg';
import i97 from '../images/poiIcons/guest_house.svg';
import i98 from '../images/poiIcons/guidepost.svg';
import i99 from '../images/poiIcons/gully.svg';
import i100 from '../images/poiIcons/hardware.svg';
import i101 from '../images/poiIcons/heliport.svg';
import i102 from '../images/poiIcons/highway-rest-area.svg';
import i103 from '../images/poiIcons/horse_riding.svg';
import i104 from '../images/poiIcons/hospital.svg';
import i105 from '../images/poiIcons/hostel.svg';
import i106 from '../images/poiIcons/hot_spring.svg';
import i107 from '../images/poiIcons/hotel.svg';
import i108 from '../images/poiIcons/hunting_stand.svg';
import i109 from '../images/poiIcons/hut.svg';
import i110 from '../images/poiIcons/ice_cream.svg';
import i111 from '../images/poiIcons/industry.svg';
import i112 from '../images/poiIcons/information.svg';
import i113 from '../images/poiIcons/internet_cafe.svg';
import i114 from '../images/poiIcons/kissing_gate.svg';
import i115 from '../images/poiIcons/lean_to.svg';
import i116 from '../images/poiIcons/library.svg';
import i117 from '../images/poiIcons/lift_gate.svg';
import i118 from '../images/poiIcons/lighthouse.svg';
import i119 from '../images/poiIcons/logging.svg';
import i120 from '../images/poiIcons/manger.svg';
import i121 from '../images/poiIcons/manor.svg';
import i122 from '../images/poiIcons/map.svg';
import i123 from '../images/poiIcons/mast_other.svg';
import i124 from '../images/poiIcons/memorial.svg';
import i125 from '../images/poiIcons/memorial_stone.svg';
import i126 from '../images/poiIcons/mine.svg';
import i127 from '../images/poiIcons/miniature_golf.svg';
import i128 from '../images/poiIcons/monument.svg';
import i129 from '../images/poiIcons/motel.svg';
import i130 from '../images/poiIcons/motorcycle_barrier.svg';
import i131 from '../images/poiIcons/motorcycle_parking.svg';
import i132 from '../images/poiIcons/museum.svg';
import i133 from '../images/poiIcons/nightclub.svg';
import i134 from '../images/poiIcons/not_drinking_spring.svg';
import i135 from '../images/poiIcons/obelisk.svg';
import i136 from '../images/poiIcons/office.svg';
import i137 from '../images/poiIcons/outdoor_seating.svg';
import i138 from '../images/poiIcons/palace.svg';
import i139 from '../images/poiIcons/park.svg';
import i140 from '../images/poiIcons/parking.svg';
import i141 from '../images/poiIcons/parking_tickets.svg';
import i142 from '../images/poiIcons/peak.svg';
import i143 from '../images/poiIcons/pharmacy.svg';
import i144 from '../images/poiIcons/picnic_shelter.svg';
import i145 from '../images/poiIcons/picnic_table.svg';
import i146 from '../images/poiIcons/pitch.svg';
import i147 from '../images/poiIcons/place_of_worship.svg';
import i148 from '../images/poiIcons/plaque.svg';
import i149 from '../images/poiIcons/playground.svg';
import i150 from '../images/poiIcons/police.svg';
import i151 from '../images/poiIcons/post_box.svg';
import i152 from '../images/poiIcons/post_office.svg';
import i153 from '../images/poiIcons/prison.svg';
import i154 from '../images/poiIcons/pub.svg';
import i155 from '../images/poiIcons/public_bath.svg';
import i156 from '../images/poiIcons/public_bookcase.svg';
import i157 from '../images/poiIcons/public_transport.svg';
import i158 from '../images/poiIcons/public_transport_tickets.svg';
import i161 from '../images/poiIcons/racetrack.svg';
import i159 from '../images/poiIcons/racetrack-cycling.svg';
import i160 from '../images/poiIcons/racetrack-horse.svg';
import i164 from '../images/poiIcons/rail.svg';
import i162 from '../images/poiIcons/rail-light.svg';
import i163 from '../images/poiIcons/rail-metro.svg';
import i165 from '../images/poiIcons/ranger-station.svg';
import i166 from '../images/poiIcons/recycling.svg';
import i167 from '../images/poiIcons/refitted_drinking_spring.svg';
import i168 from '../images/poiIcons/refitted_not_drinking_spring.svg';
import i169 from '../images/poiIcons/refitted_spring.svg';
import i170 from '../images/poiIcons/rental_bicycle.svg';
import i171 from '../images/poiIcons/rental_car.svg';
import i172 from '../images/poiIcons/residential-community.svg';
import i173 from '../images/poiIcons/restaurant.svg';
import i174 from '../images/poiIcons/rock.svg';
import i175 from '../images/poiIcons/ruins.svg';
import i176 from '../images/poiIcons/saddle.svg';
import i177 from '../images/poiIcons/sauna.svg';
import i178 from '../images/poiIcons/shelter.svg';
import i180 from '../images/poiIcons/shop/alcohol.svg';
import i181 from '../images/poiIcons/shop/art.svg';
import i182 from '../images/poiIcons/shop/bag.svg';
import i183 from '../images/poiIcons/shop/bakery.svg';
import i184 from '../images/poiIcons/shop/beauty.svg';
import i185 from '../images/poiIcons/shop/bed.svg';
import i186 from '../images/poiIcons/shop/beverages.svg';
import i187 from '../images/poiIcons/shop/bicycle.svg';
import i188 from '../images/poiIcons/shop/book.svg';
import i189 from '../images/poiIcons/shop/bookmaker.svg';
import i190 from '../images/poiIcons/shop/butcher.svg';
import i191 from '../images/poiIcons/shop/car.svg';
import i192 from '../images/poiIcons/shop/car_parts.svg';
import i193 from '../images/poiIcons/shop/car_repair.svg';
import i194 from '../images/poiIcons/shop/carpet.svg';
import i195 from '../images/poiIcons/shop/charity.svg';
import i196 from '../images/poiIcons/shop/chemist.svg';
import i197 from '../images/poiIcons/shop/clothes.svg';
import i198 from '../images/poiIcons/shop/coffee.svg';
import i199 from '../images/poiIcons/shop/computer.svg';
import i200 from '../images/poiIcons/shop/confectionery.svg';
import i201 from '../images/poiIcons/shop/convenience.svg';
import i202 from '../images/poiIcons/shop/copyshop.svg';
import i203 from '../images/poiIcons/shop/dairy.svg';
import i204 from '../images/poiIcons/shop/deli.svg';
import i205 from '../images/poiIcons/shop/department_store.svg';
import i206 from '../images/poiIcons/shop/diy.svg';
import i207 from '../images/poiIcons/shop/electronics.svg';
import i208 from '../images/poiIcons/shop/fabric.svg';
import i209 from '../images/poiIcons/shop/florist.svg';
import i210 from '../images/poiIcons/shop/furniture.svg';
import i211 from '../images/poiIcons/shop/garden_centre.svg';
import i212 from '../images/poiIcons/shop/gift.svg';
import i213 from '../images/poiIcons/shop/greengrocer.svg';
import i214 from '../images/poiIcons/shop/hairdresser.svg';
import i215 from '../images/poiIcons/shop/hifi.svg';
import i216 from '../images/poiIcons/shop/houseware.svg';
import i217 from '../images/poiIcons/shop/interior_decoration.svg';
import i218 from '../images/poiIcons/shop/jewelry.svg';
import i219 from '../images/poiIcons/shop/laundry.svg';
import i220 from '../images/poiIcons/shop/marketplace.svg';
import i221 from '../images/poiIcons/shop/massage.svg';
import i222 from '../images/poiIcons/shop/medical_supply.svg';
import i223 from '../images/poiIcons/shop/mobile_phone.svg';
import i224 from '../images/poiIcons/shop/music.svg';
import i225 from '../images/poiIcons/shop/musical_instrument.svg';
import i226 from '../images/poiIcons/shop/newsagent.svg';
import i227 from '../images/poiIcons/shop/optician.svg';
import i228 from '../images/poiIcons/shop/outdoor.svg';
import i229 from '../images/poiIcons/shop/paint.svg';
import i230 from '../images/poiIcons/shop/perfumery.svg';
import i231 from '../images/poiIcons/shop/pet.svg';
import i232 from '../images/poiIcons/shop/photo.svg';
import i233 from '../images/poiIcons/shop/seafood.svg';
import i234 from '../images/poiIcons/shop/second_hand.svg';
import i235 from '../images/poiIcons/shop/shoes.svg';
import i236 from '../images/poiIcons/shop/sports.svg';
import i237 from '../images/poiIcons/shop/stationery.svg';
import i238 from '../images/poiIcons/shop/supermarket.svg';
import i239 from '../images/poiIcons/shop/tea.svg';
import i240 from '../images/poiIcons/shop/ticket.svg';
import i241 from '../images/poiIcons/shop/tobacco.svg';
import i242 from '../images/poiIcons/shop/toys.svg';
import i243 from '../images/poiIcons/shop/trade.svg';
import i244 from '../images/poiIcons/shop/travel_agency.svg';
import i245 from '../images/poiIcons/shop/tyres.svg';
import i246 from '../images/poiIcons/shop/variety_store.svg';
import i247 from '../images/poiIcons/shop/vending_machine.svg';
import i248 from '../images/poiIcons/shop/video.svg';
import i249 from '../images/poiIcons/shop/video_games.svg';
import i179 from '../images/poiIcons/shop.svg';
import i250 from '../images/poiIcons/shower.svg';
import i251 from '../images/poiIcons/sinkhole.svg';
import i252 from '../images/poiIcons/skateboard.svg';
import i253 from '../images/poiIcons/slipway.svg';
import i254 from '../images/poiIcons/social_facility.svg';
import i255 from '../images/poiIcons/sport/archery.svg';
import i256 from '../images/poiIcons/sport/baseball.svg';
import i257 from '../images/poiIcons/sport/diving.svg';
import i258 from '../images/poiIcons/sport/gym.svg';
import i259 from '../images/poiIcons/sport/gymnasium.svg';
import i260 from '../images/poiIcons/sport/hillclimbing.svg';
import i261 from '../images/poiIcons/sport/iceskating.svg';
import i262 from '../images/poiIcons/sport/motorracing.svg';
import i263 from '../images/poiIcons/sport/skiing_crosscountry.svg';
import i264 from '../images/poiIcons/sport/skiing_downhill.svg';
import i265 from '../images/poiIcons/sport/soccer.svg';
import i266 from '../images/poiIcons/sport/swimming_outdoor.svg';
import i267 from '../images/poiIcons/sport/tennis.svg';
import i268 from '../images/poiIcons/spring.svg';
import i269 from '../images/poiIcons/stadium.svg';
import i270 from '../images/poiIcons/stairs.svg';
import i271 from '../images/poiIcons/statue.svg';
import i272 from '../images/poiIcons/stile.svg';
import i273 from '../images/poiIcons/stone.svg';
import i274 from '../images/poiIcons/table-tennis.svg';
import i275 from '../images/poiIcons/taxi.svg';
import i276 from '../images/poiIcons/telephone.svg';
import i277 from '../images/poiIcons/terminal.svg';
import i278 from '../images/poiIcons/theatre.svg';
import i279 from '../images/poiIcons/toilets.svg';
import i280 from '../images/poiIcons/toll.svg';
import i281 from '../images/poiIcons/toll_booth.svg';
import i282 from '../images/poiIcons/tower_communication.svg';
import i283 from '../images/poiIcons/tower_observation.svg';
import i284 from '../images/poiIcons/tower_other.svg';
import i285 from '../images/poiIcons/town.svg';
import i286 from '../images/poiIcons/townhall.svg';
import i287 from '../images/poiIcons/traffic_signals.svg';
import i288 from '../images/poiIcons/tree.svg';
import i290 from '../images/poiIcons/tree_protected.svg';
import i289 from '../images/poiIcons/tree2.svg';
import i291 from '../images/poiIcons/tunnel.svg';
import i292 from '../images/poiIcons/university.svg';
import i293 from '../images/poiIcons/vehicle_inspection.svg';
import i294 from '../images/poiIcons/veterinary.svg';
import i295 from '../images/poiIcons/viewpoint.svg';
import i296 from '../images/poiIcons/village.svg';
import i297 from '../images/poiIcons/volcano.svg';
import i298 from '../images/poiIcons/volleyball.svg';
import i299 from '../images/poiIcons/warehouse.svg';
import i300 from '../images/poiIcons/waste_basket.svg';
import i301 from '../images/poiIcons/waste_disposal.svg';
import i302 from '../images/poiIcons/watch.svg';
import i303 from '../images/poiIcons/water_park.svg';
import i304 from '../images/poiIcons/water_tower.svg';
import i305 from '../images/poiIcons/water_well.svg';
import i306 from '../images/poiIcons/water_works.svg';
import i307 from '../images/poiIcons/waterfall.svg';
import i308 from '../images/poiIcons/watering_place.svg';
import i309 from '../images/poiIcons/watermill.svg';
import i310 from '../images/poiIcons/wayside_shrine.svg';
import i311 from '../images/poiIcons/weather_shelter.svg';
import i312 from '../images/poiIcons/wetland.svg';
import i313 from '../images/poiIcons/wilderness_hut.svg';
import i314 from '../images/poiIcons/windmill.svg';
import i315 from '../images/poiIcons/zoo.svg';

export type PoiIconBBox = readonly [
  lx: number,
  ly: number,
  bw: number,
  bh: number,
  vbW: number,
  vbH: number,
];

export const poiIconBBoxes: Record<string, PoiIconBBox> = {
  [i0]: [1, 0.5, 13, 13.5, 15, 15],
  [i1]: [1.5, 1.5, 12, 12, 15, 15],
  [i2]: [1.5, 1.5, 14, 14.021, 17, 17.024],
  [i3]: [1, 3, 13, 9, 15, 15],
  [i4]: [2, 0.829, 11, 13.171, 15, 15],
  [i5]: [-0.002, -0.002, 102.605, 122.862, 102.63, 122.88],
  [i6]: [1.5, 1.5, 14, 14, 17, 17],
  [i7]: [1.5, 1.5, 14.626, 10, 17.633, 13],
  [i8]: [1.5, 1.5, 13, 14, 16, 17],
  [i9]: [0, 0.002, 14, 14, 14, 14],
  [i10]: [1.5, 1.5, 8, 14, 11, 17],
  [i11]: [0, 0, 14, 14, 14, 14],
  [i12]: [1.5, 1.5, 11, 11, 14, 14],
  [i13]: [0, 0, 14, 14, 14, 14],
  [i14]: [1.5, 1.5, 12, 12, 15, 15],
  [i15]: [1.5, 1.5, 15.621, 13.811, 18.621, 16.81],
  [i16]: [1.5, 1.5, 13.016, 13, 16.016, 16],
  [i17]: [1, 0, 12, 14, 14, 14],
  [i18]: [1.001, 1.025, 13, 11.975, 15, 15],
  [i19]: [0, 0, 14, 14, 14, 14],
  [i20]: [1.5, 1.5, 14.032, 11.005, 17.032, 14.004],
  [i21]: [3, 0, 8, 14, 14, 14],
  [i22]: [1.5, 1.5, 10, 4, 13, 7],
  [i23]: [0, 0, 14, 14, 14, 14],
  [i24]: [1, 0, 12, 14, 14, 14],
  [i25]: [0, 0, 14, 14, 14, 14],
  [i26]: [1.5, 1.5, 14, 13.784, 17, 16.784],
  [i27]: [1.5, 1.5, 14, 14, 17, 17],
  [i28]: [0, 0, 14, 14, 14, 14],
  [i29]: [1.5, 1.5, 6, 8, 9, 11],
  [i30]: [1, 0.999, 12.631, 13.001, 15, 15],
  [i31]: [0, 3, 15, 8, 15, 15],
  [i32]: [1.5, 1.5, 11.992, 9.99, 14.992, 12.99],
  [i33]: [1.5, 1.505, 14, 8, 17, 11.005],
  [i34]: [0, 0, 14, 14, 14, 14],
  [i35]: [1.5, 1.706, 11, 13.478, 14, 17],
  [i36]: [1.5, 1.5, 8, 10, 11, 13],
  [i37]: [2, 0, 10, 14, 14, 14],
  [i38]: [1.5, 1.5, 14, 12, 17, 15],
  [i39]: [1.5, 1.5, 14, 14, 17, 17],
  [i40]: [0, 0, 14, 14, 14, 14],
  [i41]: [0, 0.28, 3.677, 3.151, 3.704, 3.704],
  [i42]: [1.5, 1.5, 14, 12, 17, 15],
  [i43]: [0.529, 1.058, 2.646, 1.852, 3.704, 3.704],
  [i44]: [1.5, 1.5, 14, 9, 17, 12],
  [i45]: [2.999, 1, 9.002, 13, 15, 15],
  [i46]: [1.5, 1.5, 13.999, 12.534, 16.988, 15.534],
  [i47]: [0, 0, 14, 14, 14, 14],
  [i48]: [1.5, 1.5, 12, 14, 14.999, 17],
  [i49]: [1.5, 1.5, 11, 17, 14, 20],
  [i50]: [1.5, 1.5, 14, 13, 17, 16],
  [i51]: [2, 2, 10.998, 10.998, 15, 15],
  [i52]: [0, 0, 14, 14, 14, 14],
  [i53]: [1, 2, 13, 11, 15, 15],
  [i54]: [1.5, 1.5, 14, 12, 17, 15],
  [i55]: [1, -0.025, 13, 13.025, 15, 15],
  [i56]: [0, 0, 14, 14, 14, 14],
  [i57]: [1.995, 0, 12.755, 14, 15, 15],
  [i58]: [1.5, 1.5, 7, 10, 10, 13],
  [i59]: [0, 0, 14, 14, 14, 14],
  [i60]: [1.5, 1.5, 17.207, 10, 20.207, 13],
  [i61]: [0.985, 0, 13.029, 15.034, 15, 15],
  [i62]: [1, 2, 13.004, 11.902, 15, 15],
  [i63]: [0, 0, 14, 14, 14, 14],
  [i64]: [0, 0, 14, 14, 14, 14],
  [i65]: [0, 0, 24, 24, 28, 28],
  [i66]: [0.75, 1.16, 12.5, 11.68, 14, 14],
  [i67]: [1.5, 1.5, 12, 14, 15, 17],
  [i68]: [-0.25, -0.25, 12.5, 15.5, 12, 15],
  [i69]: [-0.5, -0.5, 11, 6, 10, 10],
  [i70]: [9.914, 0, 458.273, 478.103, 478.102, 478.102],
  [i71]: [10.752, 0, 476.13, 497.635, 497.634, 497.634],
  [i72]: [9.556, 0, 458.273, 477.386, 477.386, 477.386],
  [i73]: [0, 0, 12, 12, 12, 12],
  [i74]: [-0.25, -0.25, 12.5, 18, 12, 17.5],
  [i75]: [1.5, 1, 11.503, 12.98, 15, 15],
  [i76]: [0, 0, 14, 14, 14, 14],
  [i77]: [1, 1, 12, 13, 15, 15],
  [i78]: [0, 0, 14, 14, 14, 14],
  [i79]: [1, 1, 13, 11, 15, 15],
  [i80]: [1.5, 1.5, 13.5, 9, 16.5, 12],
  [i81]: [0, 0, 128, 128, 128, 128],
  [i82]: [1, 2.306, 13, 9.694, 15, 15],
  [i83]: [0, 0, 14, 14, 14, 14],
  [i84]: [1.5, 1.5, 10, 14, 13, 17],
  [i85]: [1.496, 1.5, 12.01, 14.013, 15.01, 17.008],
  [i86]: [0, 0, 14, 14, 14, 14],
  [i87]: [0, 0, 5.754, 9.725, 5.754, 9.725],
  [i88]: [1.492, 1.495, 13.495, 10.125, 16.479, 13.115],
  [i89]: [1.5, 1.5, 13.4, 7.46, 16.4, 10.46],
  [i90]: [0, 0, 14, 14, 14, 14],
  [i91]: [0, 0, 14, 14, 14, 14],
  [i92]: [1.5, 1.5, 14, 13.985, 17, 16.985],
  [i93]: [1.497, 1.503, 11.997, 11.939, 14.984, 14.942],
  [i94]: [1.5, 1.5, 12, 14, 15, 17],
  [i95]: [1.5, 1.5, 6, 5, 9, 8],
  [i96]: [1.768, 1.25, 16.463, 17.5, 20, 20],
  [i97]: [1.5, 1.5, 14, 13, 17, 16],
  [i98]: [1.5, 1.5, 12, 13, 16, 16],
  [i99]: [-0.25, -0.25, 12.5, 8.5, 12, 8],
  [i100]: [1, 0.975, 13.024, 13.025, 15, 15],
  [i101]: [0, 2, 15, 10, 15, 15],
  [i102]: [1, 1.009, 13, 12.991, 15, 15],
  [i103]: [1.5, 1.553, 14, 13.895, 17, 17],
  [i104]: [1.5, 1.5, 14, 14, 17, 17],
  [i105]: [1.5, 1.5, 14, 14, 17, 17],
  [i106]: [2.612, 1.158, 8.777, 11.684, 14, 14],
  [i107]: [1.5, 1.5, 14, 8, 17, 11],
  [i108]: [1.5, 1.5, 8, 12.094, 11, 15.094],
  [i109]: [0.5, 0.5, 17, 14, 50, 50],
  [i110]: [0, 0, 14, 14, 14, 14],
  [i111]: [1, 1, 13, 12, 15, 15],
  [i112]: [4, 1, 7, 12, 15, 15],
  [i113]: [0, 0, 14, 14, 14, 14],
  [i114]: [1, 1, 12, 12, 14, 14],
  [i115]: [1.491, 1.5, 13.531, 15, 16.513, 18],
  [i116]: [0, 0, 14, 14, 14, 14],
  [i117]: [1.5, 1.5, 6, 5, 9, 8],
  [i118]: [0, 0, 14, 14, 14, 14],
  [i119]: [0.998, 0.999, 13.003, 12.569, 15, 15],
  [i120]: [1.5, 1.5, 10.371, 8.867, 13.371, 11.867],
  [i121]: [1.5, 1.5, 14, 12, 17, 15],
  [i122]: [1.5, 1.5, 14, 12.002, 17, 15.002],
  [i123]: [1.613, -0.5, 10.774, 16, 14, 14],
  [i124]: [1.5, 1.5, 12, 13, 15, 16],
  [i125]: [0, 2, 14, 9.99, 14, 14],
  [i126]: [1.492, 1.5, 12.226, 11.057, 15.187, 14.035],
  [i127]: [1.486, 1.5, 17.776, 17.502, 20.761, 20.502],
  [i128]: [1.5, 1.5, 9, 14, 12, 17],
  [i129]: [1.5, 1.5, 14, 14, 17, 17],
  [i130]: [3, 0, 8, 14, 14, 14],
  [i131]: [0, 0, 14, 14, 14, 14],
  [i132]: [1.5, 1.5, 14, 12, 17, 15],
  [i133]: [0, 0, 15, 15, 15, 15],
  [i134]: [0.75, 1.16, 12.5, 11.68, 14, 14],
  [i135]: [3, 0, 8, 14, 14, 14],
  [i136]: [1.5, 1.5, 14, 14, 17, 17],
  [i137]: [1.5, 1.5, 14, 14, 17, 17],
  [i138]: [0, 0, 14, 14, 14, 14],
  [i139]: [2.021, 1.03, 11.98, 12.97, 15, 15],
  [i140]: [1.5, 1.5, 5.135, 6.992, 8.135, 9.992],
  [i141]: [0, 0, 14, 14, 14, 14],
  [i142]: [0, 0.5, 8, 6, 8, 6.5],
  [i143]: [1.5, 1.5, 10, 14, 13, 17],
  [i144]: [1.512, 1.5, 13.231, 13.966, 16.255, 16.971],
  [i145]: [1.5, 1.5, 12, 8.68, 15, 11.68],
  [i146]: [2, 1, 11, 13, 15, 15],
  [i147]: [0, 0, 14, 14, 14, 14],
  [i148]: [0, 0, 14, 14, 14, 14],
  [i149]: [1.5, 1.501, 14, 13.003, 17, 16.003],
  [i150]: [1.5, 1.5, 10, 14, 13, 17],
  [i151]: [1.5, 1.5, 12, 12, 15, 15],
  [i152]: [1.5, 1.5, 14, 10, 17, 13],
  [i153]: [0, 0, 14, 14, 14, 14],
  [i154]: [1.5, 1.5, 10, 12, 13, 15],
  [i155]: [0, 0, 14, 14, 14, 14],
  [i156]: [0, 0, 14, 13, 14, 14],
  [i157]: [1.5, 1.5, 11, 16.001, 14, 19.001],
  [i158]: [-0.001, -0.004, 14, 14, 14, 14],
  [i159]: [0, 1, 15, 12, 15, 15],
  [i160]: [0, 1, 14.572, 11.665, 15, 15],
  [i161]: [2, 1, 10.992, 13, 15, 15],
  [i162]: [3, 0, 9, 15, 15, 15],
  [i163]: [3, 0, 9, 15, 15, 15],
  [i164]: [2, 1, 11, 14, 15, 15],
  [i165]: [2, 0.5, 11, 13.5, 15, 15],
  [i166]: [0, 0, 14, 14, 14, 14],
  [i167]: [1.237, 0.146, 11.342, 13.854, 14, 14],
  [i168]: [1.237, 0.146, 11.342, 13.854, 14, 14],
  [i169]: [1.562, 0.146, 10.877, 13.854, 14, 14],
  [i170]: [0, 0, 14, 14, 14, 14],
  [i171]: [0, 0, 14, 14, 14, 14],
  [i172]: [1, 1, 13, 12, 15, 15],
  [i173]: [1.5, 1.5, 12, 14, 15, 17],
  [i174]: [1.5, 1.5, 10, 10, 13, 13],
  [i175]: [1.5, 1.5, 12, 12, 15, 15],
  [i176]: [0, 0.5, 8, 5, 8, 5.5],
  [i177]: [1.498, 1.5, 13.889, 13.964, 16.887, 16.957],
  [i178]: [1.501, 1.502, 11.638, 12, 14.64, 15.002],
  [i179]: [1.167, 1, 12.656, 12, 15, 15],
  [i180]: [0, 0, 14, 14, 14, 14],
  [i181]: [0, 0, 14, 14, 14, 14],
  [i182]: [0, 0, 14, 14, 14, 14],
  [i183]: [0, 0, 14, 14, 14, 14],
  [i184]: [0, 0, 14, 14, 14, 14],
  [i185]: [0, 1.531, 14, 9.469, 14, 14],
  [i186]: [0, 0, 14, 14, 14, 14],
  [i187]: [0, 0, 14, 14, 14, 14],
  [i188]: [21.508, 0, 472.063, 515.08, 515.079, 515.079],
  [i189]: [0, 0, 3.704, 3.704, 3.704, 3.704],
  [i190]: [1.792, 0.815, 10.842, 12.426, 14, 14],
  [i191]: [0, -1, 14, 14, 14, 14],
  [i192]: [0, 0, 14, 14, 14, 14],
  [i193]: [1, 0, 12, 14, 14, 14],
  [i194]: [0, 0, 14, 14, 14, 14],
  [i195]: [0, 0, 14, 14, 14, 14],
  [i196]: [0, 0, 14, 14, 14, 14],
  [i197]: [0, 0, 14, 14, 14, 14],
  [i198]: [0, 0, 14, 13.152, 14, 14],
  [i199]: [0, 0, 14, 14, 14, 14],
  [i200]: [0, 0, 14, 14, 14, 14],
  [i201]: [0, 0, 14, 14, 14, 14],
  [i202]: [0, -0.031, 14, 14.031, 14, 14],
  [i203]: [0, 0, 14, 14, 14, 14],
  [i204]: [0, 0, 14, 14, 14, 14],
  [i205]: [0, 0, 14, 14, 14, 14],
  [i206]: [0, 0, 14, 14, 14, 14],
  [i207]: [0, 0, 14, 14, 14, 14],
  [i208]: [0, 0, 14, 14, 14, 14],
  [i209]: [0, 0, 14, 14, 14, 14],
  [i210]: [0, 0, 14, 14, 14, 14],
  [i211]: [0, 0, 14, 14, 14, 14],
  [i212]: [0, 0, 14, 14, 14, 14],
  [i213]: [0, 0, 14, 14, 14, 14],
  [i214]: [0, 0, 14, 14, 14, 14],
  [i215]: [0, 0, 14, 14, 14, 14],
  [i216]: [0, 0.75, 13.5, 13.25, 14, 14],
  [i217]: [0, 0, 14, 14, 14, 14],
  [i218]: [0, -0.031, 14, 14.031, 14, 14],
  [i219]: [0, 0, 14, 14, 14, 14],
  [i220]: [0, 0, 14, 14, 14, 14],
  [i221]: [0, 1, 14, 12, 14, 14],
  [i222]: [0.048, 0, 13.905, 14, 14, 14],
  [i223]: [0, 0, 14, 14, 14, 14],
  [i224]: [0, 0, 14.001, 14, 14, 14],
  [i225]: [0, 0, 14, 14, 14, 14],
  [i226]: [0, 0, 14, 14, 14, 14],
  [i227]: [0, 0, 14, 14, 14, 14],
  [i228]: [0, 0, 14, 14, 14, 14],
  [i229]: [0, 0, 14, 14, 14, 14],
  [i230]: [0, 0, 14, 14, 14, 14],
  [i231]: [0, 0, 14.001, 14, 14, 14],
  [i232]: [0, 0, 14.05, 14.035, 14, 14],
  [i233]: [0, 0, 14, 14, 14, 14],
  [i234]: [0, 0, 14, 14, 14, 14],
  [i235]: [0, 0, 14, 14, 14, 14],
  [i236]: [0, 0, 14, 14, 14, 14],
  [i237]: [0, 0, 14, 14, 14, 14],
  [i238]: [0, 0, 14, 14, 14, 14],
  [i239]: [-0.001, 0, 14.001, 14, 14, 14],
  [i240]: [0, 3, 14, 8, 14, 14],
  [i241]: [0, 0, 14, 14, 14, 14],
  [i242]: [0, 0, 14, 14, 14, 14],
  [i243]: [0, 0, 14, 14, 14, 14],
  [i244]: [0, -0.513, 14.727, 14.513, 14, 14],
  [i245]: [-2, -0.75, 14.042, 14, 13.125, 13.125],
  [i246]: [0, 0, 14, 14, 14, 14],
  [i247]: [0, 2.79, 509.09, 503.511, 509.09, 509.09],
  [i248]: [-2.117, 0, 5.824, 3.704, 3.704, 3.704],
  [i249]: [0.105, -0.06, 13.96, 14.043, 14, 14],
  [i250]: [0, -0.009, 14, 14.009, 14, 14],
  [i251]: [1.5, 1.5, 14, 14.001, 17, 17],
  [i252]: [1.25, 5, 12.5, 6, 15, 15],
  [i253]: [2, 2.145, 13, 9.855, 15, 15],
  [i254]: [0, 0, 14, 14, 14, 14],
  [i255]: [96.031, 0, 335.939, 528, 528, 528],
  [i256]: [108.082, 0, 306.642, 522.807, 522.807, 522.807],
  [i257]: [11.742, 0, 465.834, 489.319, 489.319, 489.319],
  [i258]: [41.087, 0, 442.34, 524.514, 524.514, 524.514],
  [i259]: [98.447, -4.346, 344.326, 545.564, 541.219, 541.219],
  [i260]: [0.909, 0, 461.549, 463.367, 463.367, 463.367],
  [i261]: [8.136, 0, 478.492, 494.765, 494.765, 494.765],
  [i262]: [54.957, 0, 363.382, 473.296, 473.296, 473.296],
  [i263]: [0, 14.978, 512.839, 482.883, 512.839, 512.839],
  [i264]: [0, 12.63, 472.288, 447.029, 472.288, 472.288],
  [i265]: [0, 12.859, 538.063, 512.344, 538.063, 538.063],
  [i266]: [0, 64.077, 470.967, 342.812, 470.967, 470.967],
  [i267]: [1.5, 1.5, 13, 13, 16, 16],
  [i268]: [2.61, 1.155, 8.78, 11.69, 14, 14],
  [i269]: [2, 1, 11, 12.5, 15, 15],
  [i270]: [0, 64, 832, 832, 1024, 1024],
  [i271]: [4, 0, 6, 14, 14, 14],
  [i272]: [1.058, 0.529, 1.588, 2.646, 3.704, 3.704],
  [i273]: [1.505, 1.504, 7.379, 9.495, 10.384, 12.506],
  [i274]: [1.05, 1.063, 12.887, 12.887, 15, 15],
  [i275]: [1.5, 1.5, 14, 14, 17, 17],
  [i276]: [1.493, 1.494, 11.882, 11.896, 14.875, 14.941],
  [i277]: [0, 2.048, 15.018, 10.952, 15, 15],
  [i278]: [1.5, 1.5, 14, 14, 17, 17],
  [i279]: [1.5, 1.5, 14, 14, 17, 17],
  [i280]: [1, 1, 12.997, 13, 15, 15],
  [i281]: [0, 4.512, 13.723, 9.498, 14, 14],
  [i282]: [1.5, 2, 12, 13.524, 15, 17],
  [i283]: [1.5, 1.5, 10, 14, 13, 17],
  [i284]: [1.5, -0.5, 11, 16, 14, 14],
  [i285]: [2, 0.702, 11, 12.298, 15, 15],
  [i286]: [1.5, 1.5, 12, 14, 15, 17],
  [i287]: [4, 0, 5, 13, 13, 13],
  [i288]: [1.479, 1.5, 9.042, 14, 12, 17],
  [i289]: [0.001, 0, 9.999, 10.001, 10, 10],
  [i290]: [1.5, 1.5, 14, 14, 17, 17],
  [i291]: [1, 2, 13, 11, 15, 15],
  [i292]: [1.5, 1.5, 14, 14, 17, 17],
  [i293]: [2, 0, 10, 14, 14, 14],
  [i294]: [0, 0, 14, 14, 14, 14],
  [i295]: [1.503, 1.495, 13.241, 11.952, 16.249, 14.934],
  [i296]: [1.353, 1.103, 11.647, 11.897, 15, 15],
  [i297]: [2, 1, 11, 12, 15, 15],
  [i298]: [1.5, 1.5, 12.98, 13, 16, 16],
  [i299]: [0.985, 0.92, 13.137, 12.08, 15, 15],
  [i300]: [1.5, 1.5, 6, 8, 9, 11],
  [i301]: [1.5, 1.5, 8, 13, 11, 16],
  [i302]: [3.002, 1, 9.998, 13, 15, 15],
  [i303]: [1.5, 1.5, 14.073, 13.46, 17.073, 16.461],
  [i304]: [1.5, 1.5, 10, 14, 13, 17],
  [i305]: [1.5, 1.5, 13, 12, 16, 15],
  [i306]: [1.5, 1.5, 16, 14.725, 19, 17.708],
  [i307]: [1.5, 1.5, 13, 13, 16, 16],
  [i308]: [1.5, 1.5, 13.458, 8.007, 16.458, 11.007],
  [i309]: [1, 2, 13, 11, 15, 15],
  [i310]: [1.5, 1.5, 6, 14, 9, 17],
  [i311]: [1.5, 1.5, 14, 14, 16.999, 16.999],
  [i312]: [0.5, 0.994, 14.5, 13.014, 15, 15],
  [i313]: [1.5, 1.5, 14, 14, 17, 17],
  [i314]: [3, 0.5, 9, 13.5, 15, 15],
  [i315]: [0, 59.459, 491.086, 372.167, 491.086, 491.086],
};
